/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .component('modalPresentation', {
    templateUrl: 'app/shared/modalPresentation/ModalPresentation.html',
    controller: ModalPresentation,
    bindings: {
      resolve: '<',
      close: '&'
    }
  });

function ModalPresentation(ENV, ConfigBookingEngine) {
  var $this = this;
  $this.ENV = ENV;
  $this.showEquipment = ConfigBookingEngine.showEquipment();
}

ModalPresentation.prototype = {
  $onInit: function () {
    this.title = this.resolve.title || '';
    this.images = this.parseImages(this.resolve.images);
    this.imagesMini = this.parseImagesMini(this.resolve.images);
    this.attributes = this.resolve.attributes || [];
    this.equipments = this.resolve.equipments || [];
    if (this.resolve.description !== null) {
      this.resolve.description = this.resolve.description.replace('<hr class="ng-scope"/>', '');
    }
    this.description = this.resolve.description || '';
  },

  handleClose: function () {
    this.close();
  },

  parseImages: function (images) {
    var result = [];
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      var url = this.ENV.images.big + image.src;
      result.push({src: url});
    }

    if (result.length === 0) {
      result.push({src: '/assets/img/dummy.png'});
    }
    return result;
  },

  parseImagesMini: function (images) {
    var result = [];
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      var url = this.ENV.images.mini + image.src;
      result.push({src: url});
    }

    if (result.length === 0) {
      result.push({src: '/assets/img/dummy.png'});
    }
    return result;
  }
};
